// Store pagination constants
export const STORE_LIMIT = 50;

